/* Tasks Client barrel export */

import {
  OperationalDaysClientMocked,
  OperationalOverviewClientMocked,
  TasksClientMocked,
  TaskTemplatesClientMocked,
  TaskCategoriesClientMocked,
  TaskStatusesClientMocked,
  TaskPrioritiesClientMocked,
  TaskSchedulesClientMocked,
  TaskReportingDashboardClientMocked,
} from './tasksClientMocked';

// Re-export types
export * from './tasksTypes';
export * from './ITasksClient';

/* ---- Singleton Instances ---- */
// TaskManagement (v2) has no real backend yet — always use the in-code mocked clients.
// (Legacy v1 /tasks endpoints are separate, generated.ts-based, and do have a real backend.)

export const OperationalDaysClient = new OperationalDaysClientMocked();
export const OperationalOverviewClient = new OperationalOverviewClientMocked();
export const TasksClient = new TasksClientMocked();
export const TaskTemplatesClient = new TaskTemplatesClientMocked();
export const TaskCategoriesClient = new TaskCategoriesClientMocked();
export const TaskStatusesClient = new TaskStatusesClientMocked();
export const TaskPrioritiesClient = new TaskPrioritiesClientMocked();
export const TaskSchedulesClient = new TaskSchedulesClientMocked();
export const TaskReportingDashboardClient = new TaskReportingDashboardClientMocked();

/* ---- Factory Functions (Backwards Compatibility) ---- */

/** @deprecated Use `OperationalDaysClient` directly */
export function getOperationalDaysClient() { return OperationalDaysClient; }
/** @deprecated Use `OperationalOverviewClient` directly */
export function getOperationalOverviewClient() { return OperationalOverviewClient; }
/** @deprecated Use `TasksClient` directly */
export function getTasksClient() { return TasksClient; }
/** @deprecated Use `TaskTemplatesClient` directly */
export function getTaskTemplatesClient() { return TaskTemplatesClient; }
/** @deprecated Use `TaskCategoriesClient` directly */
export function getTaskCategoriesClient() { return TaskCategoriesClient; }
/** @deprecated Use `TaskStatusesClient` directly */
export function getTaskStatusesClient() { return TaskStatusesClient; }
/** @deprecated Use `TaskPrioritiesClient` directly */
export function getTaskPrioritiesClient() { return TaskPrioritiesClient; }
/** @deprecated Use `TaskSchedulesClient` directly */
export function getTaskSchedulesClient() { return TaskSchedulesClient; }
/** @deprecated Use `TaskReportingDashboardClient` directly */
export function getTaskReportingDashboardClient() { return TaskReportingDashboardClient; }

/* ---- Class Re-exports ---- */
export {
  OperationalDaysClientMocked,
  OperationalOverviewClientMocked,
  TasksClientMocked,
  TaskTemplatesClientMocked,
  TaskCategoriesClientMocked,
  TaskStatusesClientMocked,
  TaskPrioritiesClientMocked,
  TaskSchedulesClientMocked,
  TaskReportingDashboardClientMocked,
} from './tasksClientMocked';
